import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <Section id="pricing" variant="darker" className="border-t border-neutral-800 pb-32" data-id="element-58">
      <div className="text-center max-w-2xl mx-auto" data-id="element-59">
        <h2 className="text-3xl font-bold text-white mb-6" data-id="element-60">
          Este no es un libro para entretenerte.
        </h2>
        <p className="text-neutral-400 mb-10 text-lg" data-id="element-61">
          Es un plan para devolverte control cuando estás al límite.
        </p>

        <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-62">
          <div className="absolute top-0 left-0 w-full h-1 bg-red-600" data-id="element-63"></div>

          <div className="mb-8" data-id="element-64">
            <span className="text-5xl font-black text-white tracking-tight" data-id="element-65">
              $6.33
            </span>
            <span className="text-neutral-500 ml-2 text-lg" data-id="element-66">USD</span>
          </div>

          <Button size="xl" fullWidth className="text-lg mb-6 shadow-red-900/20 shadow-xl" data-id="element-67">
            DESCARGAR EL PLAN AHORA
          </Button>

          <div className="flex items-center justify-center gap-2 text-sm text-neutral-500 mb-8" data-id="element-68">
            <span className="w-2 h-2 bg-green-500 rounded-full" data-id="element-69"></span>
            Acceso inmediato • Pago seguro
          </div>

          <div className="text-left border-t border-neutral-800 pt-8" data-id="element-70">
            <p className="text-white font-bold mb-4" data-id="element-71">Empieza por esto hoy:</p>
            <ol className="space-y-3 text-neutral-400 text-sm" data-id="element-72">
              <li className="flex gap-3" data-id="element-73">
                <span className="bg-neutral-800 text-white w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold shrink-0" data-id="element-74">
                  1
                </span>
                Llena el diagnóstico en 15 minutos
              </li>
              <li className="flex gap-3" data-id="element-75">
                <span className="bg-neutral-800 text-white w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold shrink-0" data-id="element-76">
                  2
                </span>
                Elige 2 mínimos de energía
              </li>
              <li className="flex gap-3" data-id="element-77">
                <span className="bg-neutral-800 text-white w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold shrink-0" data-id="element-78">
                  3
                </span>
                Haz 1 acción de transición esta semana
              </li>
            </ol>
          </div>
        </div>

        <div className="mt-12" data-id="element-79">
          <p className="text-white text-xl font-medium mb-2" data-id="element-80">
            "No puedo renunciar… pero no aguanto más"
          </p>
          <p className="text-neutral-500" data-id="element-81">
            Si hoy estás en esa frase, no necesitas otra charla.
            <br data-id="element-82" />
            Necesitas un plan para mañana.
          </p>
        </div>
      </div>
    </Section>;
}